import './index.scss';
export default Manager;
declare global {
	interface Window {
		MPAComponentsManager : typeof Manager;
	}
}
;
window.MPAComponentsManager = Manager;
import Manager from './Manager';
